import { EvaluationColor } from '@repo/types';
import { ResilienceLevel } from 'components/ParticleSphere/ParticleSphere';

const EVALUATION_TO_LEVEL: Record<EvaluationColor, ResilienceLevel> = {
  red: 'low',
  orange: 'borderline',
  grey: 'typical',
  green: 'high',
};

export const evaluationToLevel = (
  evaluationColor: string | undefined | null,
): ResilienceLevel =>
  EVALUATION_TO_LEVEL[evaluationColor as EvaluationColor] ?? 'typical';
